import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

export interface ConfirmDialogData {
  title: string;
  message: string;
  details?: string[];
  confirmText?: string;
  cancelText?: string;
  confirmColor?: 'primary' | 'accent' | 'warn';
}

@Component({
  selector: 'app-confirm-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule
  ],
  template: `
    <div class="confirm-dialog">
      <h2 mat-dialog-title class="g-just-flex gap-10 align-center">
        <mat-icon [color]="data.confirmColor || 'primary'">help_outline</mat-icon>
        {{ data.title }}
      </h2>
      
      <mat-dialog-content>
        <p [innerHTML]="data.message"></p>
        
        @if(data.details && data.details.length > 0) {
          <ul class="details-list">
            @for(detail of data.details; track detail) {
              <li>{{ detail }}</li>
            }
          </ul>
        }
      </mat-dialog-content>
      
      <mat-dialog-actions align="end" class="gap-10">
        <button mat-stroked-button (click)="onCancel()">
          {{ data.cancelText || 'Cancel' }}
        </button>
        <button 
          mat-flat-button 
          [color]="data.confirmColor || 'primary'"
          (click)="onConfirm()">
          {{ data.confirmText || 'Confirm' }}
        </button>
      </mat-dialog-actions>
    </div>
  `,
  styles: [`
    .confirm-dialog {
      min-width: 350px;
    }

    mat-dialog-content {
      padding: 20px 0;
    }

    mat-dialog-content p {
      margin: 0 0 15px 0;
      color: rgba(0, 0, 0, 0.87);
    }

    .details-list {
      margin: 15px 0;
      padding-left: 20px;
      color: rgba(0, 0, 0, 0.6);
    }

    .details-list li {
      margin: 8px 0;
      line-height: 1.5;
    }

    mat-dialog-actions {
      padding: 15px 0 0 0;
      margin: 0;
    }

    .gap-10 {
      gap: 10px;
    }

    .align-center {
      align-items: center;
    }

    .g-just-flex {
      display: flex;
    }
  `]
})
export class ConfirmDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData
  ) {}

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}